export { getElementInputValue, getSerializedNodeId, hasSerializedNode, nodeAndAncestorsHaveSerializedNode, } from './serializationUtils';
export { serializeDocument } from './serializeDocument';
export { serializeNodeWithId } from './serializeNode';
export { serializeAttribute } from './serializeAttribute';
//# sourceMappingURL=index.js.map